import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import dayjs from "dayjs";
import style from "../AllowancePage/style";
import { LoadingButton } from "@mui/lab";
import Modal from "../../components/Modal";
import { getDateFormat } from "../../utils/dateFormatStore";

const AllowancePage = ({
  allowances,
  loading,
  handleCreateAllowance,
  handleEditAllowance,
  handleDeleteAllowance,
  handleCreateTravelAllowance,
  travelAllowanceData,
  handleEditTravelAllowance,
  taxPeriod,
  selectedTaxYear,
  onTaxYearChange,
  taxCountry,
}) => {
  const [allowanceText, setAllowanceText] = useState("")
  const [from, setFrom] = useState("");
  const [leave, setLeave] = useState("");
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const [dltAllowance, setDelAllowance] = useState(false);
  const [allowanceTax, setAllowanceTax] = useState(false);
  const [isPaid, setisPaid] = useState("")
  const [travelAllowances, setTravelAllowances] = useState("")
  const role = localStorage.getItem("role");
  const countryPermissions = JSON.parse(
    localStorage.getItem("countryPermissions") || "{}"
  );

  // First country permissions
  const permissions = Object.values(countryPermissions)[0] || {};

  // Allowances permission
  const canEditAllowances =
    role === "SuperAdmin" ||
    permissions?.allowances?.edit === true;

  useEffect(() => {
    // Show value even if it's 0, only skip if it's undefined or null
    if (travelAllowanceData?.[0]?.travelAllowanceRate !== undefined && travelAllowanceData[0].travelAllowanceRate !== null) {
      setTravelAllowances(travelAllowanceData[0].travelAllowanceRate.toString());
    } else {
      // If no data found, show 0 (will be created automatically)
      setTravelAllowances("0");
    }
  }, [travelAllowanceData]);

  const handleAddLeaveType = () => {
    setOpen(true);
    setFrom("create");
    setLeave("");
  };

  const deleteData = (item) => {
    setValue(item)
  }

  const handleDeleteItem = () => {
    handleDeleteAllowance(value);
    setDelAllowance(false);
  };

  const handleInputChange = (id, value) => {
    setAllowanceText((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const handleTaxChange = (id) => {
    setAllowanceTax((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleTravelAllowance = () => {
    const selectedFY = taxPeriod?.find((p) => p._id === selectedTaxYear);
    const startDate = selectedFY ? dayjs(selectedFY.start).format("YYYY-MM-DD") : "";
    const endDate = selectedFY ? dayjs(selectedFY.end).format("YYYY-MM-DD") : "";
    const country = taxCountry || "";

    if (travelAllowanceData?.[0]?._id) {
      handleEditTravelAllowance(
        travelAllowanceData[0]._id,
        Number(travelAllowances),
        100 - Number(travelAllowances),
        startDate,
        endDate,
        country
      );
    } else {
      handleCreateTravelAllowance(
        travelAllowances,
        100 - Number(travelAllowances),
        startDate,
        endDate,
        country
      );
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2, mt: 3, ml: 3, mr: 2 }}>
        <Typography sx={style.gridText}>Allowances</Typography>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography sx={style.inputText}>FY</Typography>
          <FormControl sx={{ minWidth: 200 }}>
            <Select
              value={selectedTaxYear || ""}
              onChange={onTaxYearChange}
              sx={style.selectFY}
              name="taxyear"
              displayEmpty
              renderValue={(selected) =>
                selected
                  ? taxPeriod?.find((item) => item._id === selected)
                    ? `${dayjs(taxPeriod.find((item) => item._id === selected).start).format(getDateFormat())} - ${dayjs(taxPeriod.find((item) => item._id === selected).end).format(getDateFormat())}`
                    : "Select FY"
                  : <span style={{ color: "#aaa" }}>Select FY</span>
              }
            >
              <MenuItem value="" disabled>Select FY</MenuItem>
              {taxPeriod?.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  {dayjs(item.start).format(getDateFormat())} - {dayjs(item.end).format(getDateFormat())}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {canEditAllowances && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={handleAddLeaveType}
            >
              + Add
            </Button>
          )}
        </Box>
      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={4} sx={style.gridbox}>
          <Grid container sx={style.gridContiner}>
            <Grid item xs={12} lg={12}>
              <Box sx={style.inputSection}>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                  <InputLabel sx={style.labelsAllowance}>Travel Allowances Rate</InputLabel>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={12}>
              <Box sx={{ ...style.inputSection, justifyContent: "space-between", display: "flex", alignItems: "center", mt: 2, }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={true}
                      onClick={(e) => e.preventDefault()}
                      onChange={(e) => e.preventDefault()}
                      disabled={!canEditAllowances}
                    />
                  }
                  label="Is Taxable"
                />
                <TextField
                  disabled={!canEditAllowances}
                  sx={{ width: "50%" }}
                  value={travelAllowances}
                  onChange={(e) => {
                    let input = e.target.value;
                    if (input === "") {
                      setTravelAllowances("");
                      return;
                    }
                    if (input.length > 1 && input.startsWith("0") && !input.startsWith("0.")) {
                      input = String(Number(input)); // "0005" -> "5", "01.5" -> "1.5"
                    }
                    if (!/^\d{0,3}(\.\d{0,2})?$/.test(input)) return;
                    const num = Number(input);
                    if (num >= 0 && num <= 100) {
                      setTravelAllowances(input);
                    }
                  }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  placeholder="0-100"
                />
              </Box>
            </Grid>
            <Box sx={{ ...style.btnSection, width: "100%" }}>
              <Box sx={{ ...style.btnPdf, textAlign: "right", mt: 5.5, }}>
                {canEditAllowances && (
                  <LoadingButton
                    variant="contained"
                    disabled={
                      travelAllowances === "" ||
                      travelAllowances === undefined ||
                      (travelAllowanceData?.[0]?._id &&
                        Number(travelAllowances) === travelAllowanceData[0].travelAllowanceRate)
                    }
                    onClick={() => {
                      handleTravelAllowance();
                    }}
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
        <>
          {allowances && allowances.length > 0 ? (
            <>
              {allowances.map((allowanceItem, index) => (
                <Grid item xs={12} lg={4} sx={style.gridbox} key={index}>
                  <Grid container sx={style.gridContiner}>
                    <Grid item xs={12} lg={12}>
                      <Box sx={style.inputSection}>
                        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                          <InputLabel sx={style.labels}>Allowance Type</InputLabel>
                          <Box>
                            <DeleteOutlineIcon
                              sx={{ ...style.delete, display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer", color: "#ff0000" }}
                              onClick={() => { deleteData(allowanceItem?._id); setDelAllowance(true); }}
                            />
                          </Box>
                        </Box>
                        <Box sx={style.selectGrid}>
                          <TextField
                            value={allowanceText[allowanceItem?._id] ?? allowanceItem.name}
                            onChange={(e) => handleInputChange(allowanceItem._id, e.target.value)}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <Box sx={style.inputSection}>
                        <FormControlLabel
                          sx={style.formControlLabel}
                          control={<Checkbox disabled={!canEditAllowances} />}
                          defaultChecked={allowanceItem?.isTaxable}
                          checked={allowanceTax[allowanceItem._id] ?? allowanceItem?.isTaxable}
                          onChange={() => handleTaxChange(allowanceItem._id)}
                          label="Is Taxable"
                        />
                      </Box>
                    </Grid>
                    <Box sx={{ ...style.btnSection, width: "100%" }}>
                      <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                        <LoadingButton
                          variant="contained"
                          disabled={
                            (allowanceText[allowanceItem._id]?.trim() ?? allowanceItem.name) === allowanceItem.name &&
                            (allowanceTax[allowanceItem._id] ?? allowanceItem.isTaxable) === allowanceItem.isTaxable
                          }
                          onClick={() => {
                            handleEditAllowance(
                              allowanceText[allowanceItem._id] ?? allowanceItem.name,
                              allowanceTax[allowanceItem._id] ?? allowanceItem.isTaxable,
                              allowanceItem._id
                            ); setAllowanceText("")
                          }}
                          type="submit"
                          color="primary"
                          sx={style.submitButton}
                        >
                          Save
                        </LoadingButton>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </>
          ) : (
            <Box sx={{ textAlign: "center", py: 4, width: "100%" }}>
              <Typography></Typography>
            </Box>
          )}
        </>
      </Grid>
      <Modal
        open={open}
        loading={loading}
        setOpen={setOpen}
        btnText={"Add New"}
        title={"Allowance Type"}
        handleCheck={() => {
          { handleCreateAllowance(leave, isPaid), setOpen(false) }
        }}
      >
        <Box sx={style.popupBox}>
          <Typography>
            {from === "edit" ? "Add Allowance Type" : "Add Allowance Type"}
          </Typography>
          <TextField
            sx={style.modalInput}
            name="leave"
            value={leave}
            onChange={(e) => setLeave(e.target.value)}
          />
          <FormControlLabel
            control={<Checkbox />}
            checked={isPaid}
            onChange={(e) => setisPaid(e.target.checked)}
            label="Is Taxable"
          />
        </Box>
      </Modal>

      <Modal open={dltAllowance} setOpen={setDelAllowance} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Allowance Type"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default AllowancePage;